import { numberToHex } from '../../utils/encoding/toHex.js';
export async function mine(client, { blocks, interval }) {
    await client.request({
        method: `${client.mode}_mine`,
        params: [numberToHex(blocks), numberToHex(interval || 0)],
    });
}
//# sourceMappingURL=mine.js.map